import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/config/store";
import { PageTopbar } from "@/components/page-topbar";
import { Button } from "@/components/button";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialsCard from "./materials-card";
import {
  TableList,
  TableListBody,
  TableListHeader,
  TableListPagination,
  TTableListHeaderItem,
} from "@/components/table-list";
import { Loader } from "@/components/loader";
import { IdefaultSearchParams, TOrderBy } from "@/models/types";
import { defaultSearchParams, getQueryParamsFromUrl, setParamsToUrl } from "src/utils/search-utils";
import { PrivateRoute } from "@/layouts/private-route";
import { getMaterials } from "@/reducers/materials-search.reducer";
import { MaterialsEdit } from "./materials-edit";
import { openModal } from "@/reducers/modal-reducer";
import { defaultMaterial } from "src/utils/utils";

export const MaterialsSearch = () => {
  const dispatch = useAppDispatch();
  const materialsState = useAppSelector((state) => state.materialsSearch);

  const location = useLocation();
  const navigate = useNavigate();

  const [params, setParams] = useState<IdefaultSearchParams>(
    getQueryParamsFromUrl(defaultSearchParams, location)
  );

  const onNewMaterial = () => {
    dispatch(
      openModal({
        element: <MaterialsEdit material={defaultMaterial} />,
        opt: { size: "xs", title: "Nuovo materiale" },
      })
    );
  };

  const onChangePage = (page: number) =>
    setParams({
      ...params,
      offset: params.size * page,
    });

  const getCurrentPage = Math.floor(params.offset / params.size);

  const onChangeSort = (sort: TOrderBy) => () =>
    setParams({
      ...params,
      orderBy: sort,
      order: params.order === "ASC" ? "DESC" : "ASC",
    });

  const tableHeader: TTableListHeaderItem[] = [
    {
      id: "title",
      name: "Titolo",
      onClick: onChangeSort("title"),
    },
    {
      id: "createdDate",
      name: "Data creazione",
      onClick: onChangeSort("createdDate"),
    },
    {},
  ];

  useEffect(() => {
    dispatch(getMaterials(params));
    setParamsToUrl(params, navigate);
  }, [params.orderBy, params.order, params.offset, params.size, materialsState.refresh]);

  useEffect(() => {
    setParams(getQueryParamsFromUrl(defaultSearchParams, location.search));
  }, [location.search]);

  return (
    <PrivateRoute>
      <>
        <PageTopbar title={"Materiali"}>
          <div className="button-group ml-auto">
            <Button className="button md solid primary" onClick={onNewMaterial}>
              Nuovo materiale
            </Button>
          </div>
        </PageTopbar>

        {materialsState.loading && <Loader color="#000000" />}
        {materialsState.fetchFailure && "Errore caricamento dati"}
        {!materialsState.loading && materialsState.search?.length === 0 && "Nessun dato"}

        {materialsState.search?.length > 0 && (
          <>
            <TableList className="color-black">
              <TableListHeader items={tableHeader} sortBy={params.orderBy} sortDirection={params.order} />
              <TableListBody>
                {materialsState.search?.map((material) => (
                  <MaterialsCard key={material.ID} material={material} />
                ))}
              </TableListBody>
            </TableList>
            <TableListPagination
              activePage={getCurrentPage}
              paginate={onChangePage}
              itemsPerPage={params.size}
              totalItems={materialsState.count}
            />
          </>
        )}
      </>
    </PrivateRoute>
  );
};
